import React from "react";
//#region types
import { InvoiceVouchersProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { Vouchers } from "components/voucher";
import { useInvoiceService } from "serviceHooks";

const InvoiceVouchers: React.FC<InvoiceVouchersProps> = (props) => {
  const invoiceService = useInvoiceService();
  return <Vouchers parentId={props.id} getVouchersHandler={invoiceService.getTransactions} />;
};

export default InvoiceVouchers;
